import * as React from "react"

import { Badge, Box, Button, Flex, Stack, StackDivider, Text, Tag as ChakraTag } from "@chakra-ui/react"

import { AlertBikeEntity, AlertEntity } from "../lib/types/alert"
import { AlertItem } from "./AlertItem"
import { useOrgs } from "./providers/OrgProvider"
import { useFeatFlags } from "./providers/FeatFlagProvider"

interface BicycleAlertsItemProps {
  bicycle: AlertBikeEntity
  index: number
  alerts: AlertEntity[]
  refetchAlerts: () => Promise<any>
  onSelectAlert: () => void
  onSelectBike: () => void
}

export const BikeAlertsItem: React.FC<BicycleAlertsItemProps> = (props) => {
  const { currentOrgs } = useOrgs()
  const { tags } = useFeatFlags()
  const [muteItem, setMuteItem] = React.useState(false)
  const handleShowItem = () => setMuteItem(true)
  return (
    <Box
      bg={props.index % 2 === 0 ? "gray.50" : "white"}
      p={3}
      style={{ opacity: muteItem ? 0.2 : 1 }}
      borderRadius="lg"
      my={2}
    >
      <Flex mb={1}>
        <Flex position="relative" direction="column" align="flex-start" w="100%">
          <Flex w="100%" direction="row">
            <Box width="70%">
              <Button
                outline="none"
                variant="link"
                onClick={!!props.bicycle.bicycle_coordinates ? props.onSelectBike : props.onSelectAlert}
                fontSize="1.2rem"
                justifyContent="flex-start"
                fontWeight="bold"
                color="gray.700"
                isDisabled={!!!props.bicycle.location}
              >
                {props.bicycle.bicycle_name}
              </Button>
            </Box>
            <Box width="15%" alignItems="right"></Box>
            {props.bicycle.bicycle_coordinates ? (
              <Box width="15%" alignItems="right">
                <Button
                  outline="none"
                  variant="link"
                  onClick={props.onSelectBike}
                  fontSize="1.2rem"
                  justifyContent="flex-start"
                  fontWeight="bold"
                  color="gray.700"
                  isDisabled={!!!props.bicycle.bicycle_coordinates}
                >
                  <Badge variant="outline" p="1" width="100%" position="relative">
                    Asset
                  </Badge>
                </Button>
              </Box>
            ) : (
              // default to using bicycle_coordinates;
              // and alerts if there is no bicycle_coordinates;
              // in the future users might want to toggle to show both;
              <Box width="15%" alignItems="right">
                <Button
                  outline="none"
                  variant="link"
                  onClick={props.onSelectAlert}
                  fontSize="1.2rem"
                  justifyContent="flex-start"
                  fontWeight="bold"
                  color="gray.700"
                  isDisabled={!!!props.bicycle.location}
                >
                  <Badge variant="outline" position="relative" p="1">
                    Alert
                  </Badge>
                </Button>
              </Box>
            )}
          </Flex>
          <Text fontSize="0.7rem" color="gray.500">
            {props.bicycle.lock_bleid || "N/A"}
          </Text>
        </Flex>
      </Flex>
      <Stack spacing={1} divider={<StackDivider />}>
        {props.alerts.map((alert) => {
          const alertOrg = currentOrgs.find(({ url }) => url === alert.organization)!
          return (
            <AlertItem
              key={alert.uuid}
              alert={alert}
              refetchAlerts={props.refetchAlerts}
              organization={alertOrg}
              onMuteAlert={handleShowItem}
            />
          )
        })}
      </Stack>
      {tags.visible &&
        props.bicycle.bicycle_tags?.map((tag) => {
          return (
            <ChakraTag bg={tag.tag_declaration_color} key={tag.uuid} m="2">
              {tag.tag_declaration_name}
            </ChakraTag>
          )
        })}
    </Box>
  )
}
